import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { CTExpansionPanelConfiguration, CtModelConfiguration, CtModelService, CTSingleComponentConfiguration, CTTabConfiguration } from '@ctsolution/ct-framework';
import { CTCompany } from 'projects/ct-manager/src/app/_core/classes/ct-company';
import { CTConfigurationModel } from 'projects/ct-manager/src/app/_core/classes/ct-configuration-model';
import { CtManagerService } from 'projects/ct-manager/src/app/_core/lib/ct-manager.service';

@Component({
  selector: 'app-work-order-company-information',
  templateUrl: './work-order-company-information.component.html',
  styleUrls: ['./work-order-company-information.component.scss']
})
export class WorkOrderCompanyInformationComponent {
  

    @Input() company: CTCompany | null = null;

    panelConfiguration : CTTabConfiguration | null = null;
    companyInformationConfiguration : CTConfigurationModel = CTConfigurationModel.create();
    @ViewChild('companyInformationTemplate') companyInformationTemplate!: TemplateRef<any>;

     fieldConfigs: FieldConfig[] = [
    {
      key: 'ReferenceName',
      label: 'Ragione Sociale',
      getValue: (c) => c.ReferenceName
    },
    {
      key: 'DisplayName',
      label: 'Nome Visualizzato',
      getValue: (c) => c.DisplayName
    },
    {
      key: 'Name',
      label: 'Nome',
      getValue: (c) => c.Name
    },
    {
      key: 'Surname',
      label: 'Cognome',
      getValue: (c) => c.Surname
    },
    {
      key: 'FiscalCode',
      label: 'Codice Fiscale',
      getValue: (c) => c.FiscalCode
    },
    {
      key: 'VAT',
      label: 'Partita IVA',
      getValue: (c) => c.VAT
    },
    {
      key: 'VATOrFiscalCode',
      label: 'P.IVA/CF',
      getValue: (c) => c.VATOrFiscalCode
    },
    {
      key: 'Code',
      label: 'Codice',
      getValue: (c) => c.Code
    },
    {
      key: 'FullLegalAddress',
      label: 'Indirizzo Completo',
      getValue: (c) => c.FullLegalAddress
    },
    {
      key: 'Contacts',
      label: 'Contatti',
      getValue: (c) => c.Contacts
    },
    {
      key: 'ContactsInternalReferences',
      label: 'Riferimenti Interni',
      getValue: (c) => c.ContactsInternalReferences
    },
    {
      key: 'PaymentMethod',
      label: 'Modalità di Pagamento',
      getValue: (c) => c.PaymentMethod
    },
    {
      key: 'NoteContent',
      label: 'Note',
      getValue: (c) => c.NoteContent
    },
    {
      key: 'Type',
      label: 'Tipo',
      getValue: (c) => c.Type?.Name
    },
    {
      key: 'TagsJoined',
      label: 'Tags',
      getValue: (c) => c.TagsJoined
    },
    {
      key: 'IsCustomer',
      label: 'Cliente',
      getValue: (c) => c.IsCustomer ? 'Sì' : 'No'
    },
    {
      key: 'IsSupplier',
      label: 'Fornitore',
      getValue: (c) => c.IsSupplier ? 'Sì' : 'No'
    },
    {
      key: 'IsSelf',
      label: 'Azienda Propria',
      getValue: (c) => c.IsSelf ? 'Sì' : 'No'
    },
    {
      key: 'Active',
      label: 'Attivo',
      getValue: (c) => c.Active ? 'Sì' : 'No'
    }
  ]; //TODO: Usare label con traduzione

  
  
  // Campi effettivamente visibili
  displayFields: FieldConfig[] = [];

  
    constructor(private modelService: CtModelService<any>, private managerService : CtManagerService) {
  
    }
  
    async ngAfterViewInit() {
    
      await this.managerService.getComponentOverride("workOrder", "companyInformationConfiguration", this.companyInformationConfiguration).then((component) => {
        return;
      });
  
      this.panelConfiguration = CTExpansionPanelConfiguration
      .create([
        CTSingleComponentConfiguration.create(this.companyInformationTemplate).setLabel("CompanyInformation").setExpanded(this.companyInformationConfiguration.expanded)])
        .setButtonsVisible(false);

        this.updateDisplayFields();

  
    }

   
  
  ngOnChanges(): void {
    this.updateDisplayFields();
  }
  
  private updateDisplayFields(): void {
    if (!this.company) {
      this.displayFields = [];
      return;
    }

    // Determina quali campi mostrare
    const fieldsToShow = this.companyInformationConfiguration.visibleFields;
    
    // Filtra i campi configurati in base a quelli da mostrare
    this.displayFields = this.fieldConfigs.filter(config => 
      fieldsToShow.includes(config.key)
    );
    
    // Ordina i campi secondo l'ordine nell'array visibleFields o defaultFields
    this.displayFields.sort((a, b) => {
      const indexA = fieldsToShow.indexOf(a.key);
      const indexB = fieldsToShow.indexOf(b.key);
      return indexA - indexB;
    });
  }
  
  // Metodo helper per verificare se un valore è vuoto
  isEmpty(value: any): boolean {
    return value === null || 
           value === undefined || 
           value === '' ||
           (typeof value === 'string' && value.trim() === '');
  }
  
  // Metodo per ottenere il valore formattato di un campo
  getFieldValue(field: FieldConfig): string {
    if (!this.company) return '-';
    
    const value = field.getValue(this.company);
    
    if (this.isEmpty(value)) {
      return '-';
    }
    
    return value;
  }
  
  // Metodo per verificare se ci sono dati da mostrare
  hasDataToShow(): boolean {
    return this.displayFields.length > 0 && this.company !== null;
  }

  

}

interface FieldConfig {
  key: string;
  label: string;
  getValue: (company: CTCompany) => any;
  isVisible?: boolean;
}